import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './RadioButton.scss';

class RadioButton extends React.Component {
  render() {
    let {
      name,
      value,
      checked,
      children,
      inline,
      disabled,
      onChange,
      hideIcon,
      ...rest
    } = this.props;
    return (
      <label
        className={classnames(styles.component, inline && styles.inline, disabled && styles.disabled)}
        {...rest}
      >
        <input type="radio" name={name} value={value} checked={checked} onChange={onChange} disabled={disabled} />
        {
          !hideIcon &&
          <i className={styles.icon}>
            <i></i>
          </i>
        }
        {children}
      </label>
    );
  }
}

RadioButton.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  checked: PropTypes.bool,
  children: PropTypes.node,
  inline: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  hideIcon: PropTypes.bool
};

RadioButton.defaultProps = {
  onChange: () => {}
};

export default RadioButton;